import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["badge"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Button } from 'antd';
import { styleVariables } from '../style';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonType;

(function (ButtonType) {
  ButtonType["primary"] = "primary";
  ButtonType["default"] = "default";
  ButtonType["text"] = "text";
  ButtonType["link"] = "link";
  ButtonType["dashed"] = "dashed";
})(ButtonType || (ButtonType = {}));

export var ButtonSize;

(function (ButtonSize) {
  ButtonSize["default"] = "middle";
  ButtonSize["small"] = "small";
  ButtonSize["large"] = "large";
})(ButtonSize || (ButtonSize = {}));

export var ButtonShape;

(function (ButtonShape) {
  ButtonShape["default"] = "default";
  ButtonShape["circle"] = "circle";
  ButtonShape["round"] = "round";
})(ButtonShape || (ButtonShape = {}));

var ButtonStyled = styled(Button).withConfig({
  displayName: "buttoncomponent__ButtonStyled",
  componentId: "sc-13tjpqs-0"
})(["min-width:", ";border-radius:", ";background:", ";color:", ";"], function (props) {
  switch (props.shape) {
    case ButtonShape.circle:
      return 'unset';

    case ButtonShape.round:
      return 'unset';

    default:
      return '100px';
  }
}, function (props) {
  switch (props.shape) {
    case ButtonShape.circle:
      return '50%';

    case ButtonShape.round:
      return '8px';

    default:
      return '6px';
  }
}, function (props) {
  if (props.badge && props.disabled) {
    return "".concat(props.color || styleVariables.colors.colorPrimaryBase, " !important");
  }

  switch (props.type) {
    case ButtonType.primary:
      return styleVariables.colors.colorPrimaryBase;

    case ButtonType.dashed:
      return styleVariables.colors.colorBgContainer;

    case ButtonType.text:
      return 'transparent';

    case ButtonType.link:
      return 'transparent';

    default:
      return styleVariables.colors.colorBgContainer;
  }
}, function (props) {
  if (props.badge) {
    return "".concat(styleVariables.colors.colorBgContainer, " !important");
  }
});
export var ButtonComponent = function ButtonComponent(_ref) {
  var badge = _ref.badge,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(ButtonStyled, _objectSpread(_objectSpread({
    badge: badge
  }, props), {}, {
    children: props.title
  }));
};